import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Banner from "./components/Banner";
import TransparencyPage from "./components/TransparencyPage";
import Score from "./components/Score";
import Image from "../../assets/Banner/banner1_2.jpg";

const styles = {
  paperContainer: {
    height: 350,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Home = () => {
  return (
    <Box>
      <Helmet>
        <title> BudgIT | States Fiscal Transparency League</title>
      </Helmet>
      <Box style={styles.paperContainer}>
        <Banner />
      </Box>
      <Box>
        <Container>
          <TransparencyPage />
          <Score />
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
